import { createInstance } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { i18nResources } from "@/lib/i18n/resources";
import {
  LANGUAGE_COOKIE_NAME,
  WIDGET_LANGUAGE_STORAGE_KEY,
  migrateLanguageCookieToSharedDomain,
} from "@/lib/i18n/languageSettings";

export const widgetI18n = createInstance();

migrateLanguageCookieToSharedDomain(WIDGET_LANGUAGE_STORAGE_KEY);

void widgetI18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: i18nResources,
    fallbackLng: "en",
    debug: import.meta.env.DEV,
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["cookie", "querystring", "navigator"],
      caches: [],
      lookupCookie: LANGUAGE_COOKIE_NAME,
      lookupQuerystring: "lang",
      lookupLocalStorage: WIDGET_LANGUAGE_STORAGE_KEY,
    },
  });
